import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Image from "../../components/Image";
import PublicNavbar from "../../components/PublicNavbar";
import Ratio from "../../components/Ratio";
import React from "react";
import ScheduleTable from "../../components/ScheduleTable";
import SignInForm from "../../components/SignInForm";
import Spacer from "../../components/Spacer";
import StatisticsShowcase from "../../components/StatisticsShowcase";
import background from "../../statics/img/background.jpg";
import decorBackground from "../../statics/img/event-decor.png";
import eventHeader from "../../statics/svg/event-header.svg";
import virtualEventTag from "../../statics/svg/virtual-event-tag.svg";

const Welcome = () => {
  return (
    <div className="WelcomePage">
      <PublicNavbar />

      <div
        className="relative h-screen bg-black"
        style={{
          height: "100vh",
        }}
      >
        <div className="absolute top-0 left-0">
          <img src={virtualEventTag} alt="Virtual Event" width="70%" />
        </div>
        <Image src={background}>
          <div className="relative w-full h-full">
            <div className="relative z-10 w-full h-full">
              <div className="flex flex-wrap items-center justify-center w-full h-full">
                <div className="lg:mb-64">
                  <Container>
                    <img src={eventHeader} alt="Event Header" />

                    <div className="flex items-center justify-center mt-8">
                      <SignInForm />
                    </div>
                  </Container>
                </div>
              </div>
            </div>

            <div className="absolute bottom-0 left-0 z-0 w-full">
              <Ratio w={4} h={1}>
                <Image src={decorBackground} />
              </Ratio>
            </div>
          </div>
        </Image>
      </div>
      <StatisticsShowcase
        data={[
          {
            className: "text-aqua",
            title: "Keynotes & Symposiums",
            value: 11,
            description:
              "Over 11 keynotes & symposiums contributed to this virtual conference.",
          },
          {
            className: "text-cream",
            title: "Abstracts",
            value: 104,
            description:
              "Insights from over 104 abstracts participated in dental researches across Asia-Pacific.",
          },
          {
            className: "text-black",
            title: "Awards",
            value: 6,
            description: "Over 6 awards given across SEA dental community.",
          },
        ]}
      />
      <ContainerDivider />

      <Spacer>
        <ScheduleTable isPublic={true} />
      </Spacer>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>
    </div>
  );
};

export default Welcome;
